import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
// import { createStore } from 'framework7/lite';
import { f7 } from "framework7-vue";
import VuexPersistence from 'vuex-persist';
import { baseGet, basePost, Member, Notice } from "@/js/services/baseService";
import { computed, reactive } from "vue";
import { createStore, createLogger } from 'vuex';
import { i18n } from "@/js/i18n.js";
import storage from '@/js/storage';
import creteStoreUtil from '@/store/store-util';
import modules from './modules'; // 引入modules

var defaultState = {
  // 語系
  locale: null,
  // 全站loading顯示
  isGlobalLoadingShow: false,
  // 未讀訊息數量
  notice_unread_num: 0,

  /**
   * 廣告燈箱不顯示
   * @property {number} timestamp毫秒
   */
  adModalHideUntil: '',
  adModalHideThisLogin: false,
  preOrderAdModalHideUntil: '',
  preOrderAdModalHideThisLogin: false,

  /**
   * 廣告燈箱最進一次顯示的時間
   * @property {number} timestamp毫秒
   */
  adModalLastShow: ''
};

var _creteStoreUtil = creteStoreUtil({
  defaultState: defaultState
}),
    init = _creteStoreUtil.init,
    getData = _creteStoreUtil.getData,
    setData = _creteStoreUtil.setData,
    resetData = _creteStoreUtil.resetData,
    initState = _creteStoreUtil.initState;

var vuexLocal = new VuexPersistence({
  storage: storage,
  asyncStorage: true,
  reducer: function reducer(state) {
    var result = {
      locale: state.locale,
      adModalHideUntil: state.adModalHideUntil,
      auth: {
        isLogined: state.auth.isLogined,
        token: state.auth.token,
        viewed_action_store_id: state.auth.viewed_action_store_id,
        viewed_action_store_name: state.auth.viewed_action_store_name,
        viewed_action_store_addr: state.auth.viewed_action_store_addr
      }
    };
    return result;
  }
});
var store = createStore({
  modules: modules,
  // 放到這裡
  state: function state() {
    return {
      isLogout: 0
    };
  },
  getters: {
    getData: getData
  },
  actions: {
    // 初始
    init: function init(_ref) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var commit, psArr;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit = _ref.commit;
                psArr = [];
                Object.keys(modules).forEach(function (key) {
                  var result = store.dispatch("".concat(key, "/init"));

                  if ('Promise' == result.constructor.name) {
                    psArr.push(result);
                  }
                });
                commit('initState'); // 設定語系

                if (!store.state.locale) {
                  commit('updateLocale', store.state.locale || 'tw');
                }
                /**
                 * 等待所有必要資料都準備好
                 * store.restored: https://www.npmjs.com/package/vuex-persist
                 */


                _context.next = 7;
                return Promise.all([].concat(psArr));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 更新 - 未讀訊息數量
    updateNoticeUnreadNum: function updateNoticeUnreadNum(_ref2) {
      var commit = _ref2.commit;
      return Notice.notice_unread_num().then(function (res) {
        ajax200Res(res, function (_ref3) {
          var res = _ref3.res,
              data = _ref3.data,
              msg = _ref3.msg;

          // success
          if (data) {
            commit('setData', {
              notice_unread_num: data.num
            }); // 設定app數字

            _set_badge_num(data.num);
          }
        }, function (_ref4) {
          var res = _ref4.res,
              data = _ref4.data,
              msg = _ref4.msg,
              defaultAlert = _ref4.defaultAlert;
          // fail
          defaultAlert();
        });
      });
    },
    // 更新 - 會員相關資料
    updateMemberRelatedData: function updateMemberRelatedData(_ref5) {
      var dispatch = _ref5.dispatch;
      dispatch('auth/updateMemberData').then(function () {
        // 取得會員基本資料、會員卡號後進一進取得其他會員相關資料
        // 會員點數
        // dispatch('auth/updateMemberPointRecord');
        // 待領取訂單
        dispatch('auth/updateUnreceiveOrdersNum'); // dispatch('updateMemberCoupon')
        // 未讀優惠券

        dispatch('auth/updateMemberCouponUnread'); // 未讀訊息

        dispatch('updateNoticeUnreadNum'); // 當前購物車數量

        dispatch('cart/updateCurrentCartNum'); // 取得購物車當前選擇的行動門市

        dispatch('cart/updateCurrentCartSelectedStore');
      });
    }
  },
  mutations: {
    initState: initState,
    setData: setData,
    resetData: resetData,
    // 更新語系
    updateLocale: function updateLocale(state, langStr) {
      var locale = null;

      switch (langStr) {
        case mukiConst.locale['TW']:
          locale = mukiConst.locale['TW'];
          break;

        case mukiConst.locale['EN']:
          locale = mukiConst.locale['EN'];
          break;

        default:
          break;
      }

      if (typeof i18n !== "undefined") {
        if (i18n.global.locale.value) {
          i18n.global.locale.value = locale;
        }
      }

      if (locale) {
        state.locale = locale;
        localStorage.setItem("MukiLang", locale);
      }
    },
    setLogout: function setLogout(state, value) {
      state.isLogout = value;
    }
  },
  plugins: process.env.NODE_ENV !== 'production' ? [vuexLocal.plugin] : [vuexLocal.plugin]
});
export default store;